import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  ContModulosSection,
  TitleModulos,
  DescModulos,
  ModulosGrid,
  ModuloCard,
  ModuloIcon,
  ModuloTitle,
} from './CoreBancarioModulos.styles';

import OnboardingIcon from '../../assets/images/CoreBankingModulesImages/onboarding.svg';
import AnalysisIcon from '../../assets/images/CoreBankingModulesImages/analysis.svg';
import PLDIcon from '../../assets/images/CoreBankingModulesImages/PLD.svg';
import CustomerManagementIcon from '../../assets/images/CoreBankingModulesImages/customer_management.svg';
import PortfolioManagementIcon from '../../assets/images/CoreBankingModulesImages/portfolio_management.svg';
import RegulatoryReportsIcon from '../../assets/images/CoreBankingModulesImages/regulatory_reports.svg';
import PaymentCollectionIcon from '../../assets/images/CoreBankingModulesImages/payment_collection.svg';
import CardIssuanceIcon from '../../assets/images/CoreBankingModulesImages/card_issuance.svg';
import MessageCampaignIcon from '../../assets/images/CoreBankingModulesImages/message_campaign.svg';
import ElectronicSignatureIcon from '../../assets/images/CoreBankingModulesImages/electronic_signature.svg';

const modulosData = [
  { id: 1, title: 'Onboarding Digital', icon: OnboardingIcon, route: '/onboarding' },
  { id: 2, title: 'Análisis de Crédito', icon: AnalysisIcon, route: '/analisis-crediticio' },
  { id: 3, title: 'PLD', icon: PLDIcon, route: '/pld' },
  { id: 4, title: 'Gestión de Clientes', icon: CustomerManagementIcon, route: '/onboarding' },
  { id: 5, title: 'Administración de Cartera', icon: PortfolioManagementIcon, route: '/cobranza' },
  { id: 6, title: 'Reportes Regulatorios', icon: RegulatoryReportsIcon, route: '/pld' },
  { id: 7, title: 'Recaudación de Pagos', icon: PaymentCollectionIcon, route: '/cobranza' },
  { id: 8, title: 'Emisión de Tarjetas', icon: CardIssuanceIcon, route: '/emision-tarjetas' },
  { id: 9, title: 'Campaña de Mensajes', icon: MessageCampaignIcon, route: '/notificaciones' },
  { id: 10, title: 'Firma Electrónica', icon: ElectronicSignatureIcon, route: '/onboarding' },
];

export const CoreBancarioModulos = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigate = (route) => {
    navigate(route);
  };

  return (
    <ContModulosSection>
      <TitleModulos>
        {t('Principales módulos que transforman tu operación')}
      </TitleModulos>
      <DescModulos>
        {t('Desde la originación hasta la cobranza, te acompañamos en cada etapa con módulos diseñados para que tu operación sea ágil, precisa y totalmente segura.')}
      </DescModulos>
      <ModulosGrid>
        {modulosData.map((modulo) => (
          <ModuloCard key={modulo.id} onClick={() => handleNavigate(modulo.route)}>
            <ModuloIcon>
              <img src={modulo.icon} alt={modulo.title} />
            </ModuloIcon>
            <ModuloTitle>{t(modulo.title)}</ModuloTitle>
          </ModuloCard>
        ))}
      </ModulosGrid>
    </ContModulosSection>
  );
};
